import { Component, HostListener } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Appsetting } from './model/models';
import { AppSettingsService, CommonService } from './services/api';
import { environment } from '../environments/environment';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
    //host: { 'window:beforeunload': 'doSomething' }
})

export class AppComponent {
    @HostListener('contextmenu', ['$event'])
    onRightClick(event) {
        event.preventDefault();
    }
    public baseUrl: string = '';
    constructor(private appSettingsService: AppSettingsService, private toastServ: ToastrService) {
        this.appSettingsService.getSettings();
        this.baseUrl = environment.appSetting.baseUrI;

    }
    ngOnInit() {
        //window.addEventListener("beforeunload", function (e) {
        //    var confirmationMessage = "\o/";
        //    e.returnValue = confirmationMessage;     
        //    return confirmationMessage;              
        //});
        window.addEventListener("keyup", disableF5);
        window.addEventListener("keydown", disableF5);

        function disableF5(e) {
            if ((e.which || e.keyCode) == 116) e.preventDefault();
        };
        //var self = this;
        //window.onbeforeunload = function (event) {
        //    self.toastServ.warning('Refresh not allowed.Please ');
        //}
    }
}
